<template>
  <div>
    <div class="myHead">
      <el-breadcrumb style="margin-top:20px;margin-left:20px" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/processManager'}">重大危险源监控</el-breadcrumb-item>
        <el-breadcrumb-item>监控列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.myHead {
  position: absolute;
  top: 0px;
  left: 250px;
  width: 80%;
  height: 60px;
}
</style>